import React, { useState, useRef, useEffect, useContext } from "react";
import "../styles/OpenCompanyMob.css";
import ss from "../assets/images/shersoftnavLogo.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { useLocation } from "react-router-dom";
import { useDbContext } from "../context/DbContext";
import ComboBox from "../../src/components/ComboBoxes/ComboBox";
import CustomerCodeVerification from "../components/Cdb/CustomerCodeVerification";
import EmailVerification from "../components/verificators/EmailVerification";
import exit from "../assets/images/CreateCompanyImages/Cdbexit.webp";
import opnCmp from "../assets/images/CreateCompanyImages/openCmp.webp";

function OpenCompanyMob() {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  const navigate = useNavigate();
  const [companyCode, setCompanyCode] = useState([]);
  const [cmpData, setCmpData] = useState({
    Cdata: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [emailVerificationData, setEmailVerificationData] = useState(null);
  const [emailVerificationOtp, setEmailVerificationOtp] = useState("");
  const [emailVerificationCallback, setEmailVerificationCallback] = useState(null);

  const customerCode = localStorage.getItem("customerCode");
  const fetchDatabaseNames = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${apiBaseUrl}/main/getalldatabases/${
          Array.isArray(cmpData.Cdata) ? cmpData.Cdata[0] : ""
        }`
      );
      setTableData(response.data);
      if (response.data.length > 0) {
        setHighlightedRow(0);
        // Don't automatically set selectedRowData here
      }
    } catch (error) {
      console.error("Error fetching database names:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const [selectedRowData, setSelectedRowData] = useState(null);
  const selectcmpref = useRef(null);

  const tableRef = useRef(null);
  const [tableData, setTableData] = useState([]);

  const [highlightedRow, setHighlightedRow] = useState(-1);

  const fetchCmpname = async () => {
    const customerCode = localStorage.getItem("customerCode");
    if (!customerCode) {
      return;
    }

    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getalldatabases/${customerCode}`
      );

      // Assuming response.data is an array with objects and each object has a LedName property
      const cData = response.data;
      // //////////////console.log("res",cData);

      // Transforming the array into the desired format
      // const supplName = cName.map((item) => item.LedName);

      const transformedData = cData.map((item) => [
        item.CustomerCode,
        item.name,
      ]);
      setCompanyCode(transformedData);
      // //////////////console.log(transformedData);

      // setsupplierName(supplName);
    } catch (error) {
      console.error("Error fetching company datas:", error.message);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (document.activeElement === selectcmpref.current) {
        // If ComboBox is focused, focus the table
        tableRef.current?.focus();
      } else if (tableData.length > 0 && highlightedRow >= 0) {
        // Only select if we have data and a valid highlighted row
        onRowSelect(highlightedRow);
      }
    } else if (event.key === "ArrowDown") {
      event.preventDefault(); // Prevent page scrolling
      setHighlightedRow((prev) => Math.min(prev + 1, tableData.length - 1));
    } else if (event.key === "ArrowUp") {
      event.preventDefault(); // Prevent page scrolling
      setHighlightedRow((prev) => Math.max(prev - 1, 0));
    }
  };

  const handleRowClick = (rowIndex) => {
    setHighlightedRow(rowIndex);
  };

  const onRowSelect = (rowIndex) => {
    // Pass the rowIndex parameter to ensure we're selecting the correct row
    if (rowIndex >= 0 && rowIndex < tableData.length) {
      const selectedRow = tableData[rowIndex];
      setSelectedRowData(selectedRow);
      navigateToLogin(selectedRow);
    }
  };

  const handleOpenButtonClick = () => {
    if (highlightedRow >= 0 && highlightedRow < tableData.length) {
      const selectedRow = tableData[highlightedRow];
      navigateToLogin(selectedRow);
    }
  };

  const navigateToLogin = (selectedRow) => {
    if (selectedRow && selectedRow.Code) {
      localStorage.setItem("dbCode", selectedRow.Code);
      sessionStorage.setItem("dbCode", selectedRow.Code);
      if (selectedRow.name) {
        localStorage.setItem("dbName", selectedRow.name);
        sessionStorage.setItem("dbName", selectedRow.name);
      }
    }
    navigate("/login", { state: { selectedRowData: selectedRow } });
  };

  const handleExitButtonClick = () => {
    navigate("/");
  };

  useEffect(() => {
    //////////////////console.log("Updated Selected Row Data:", selectedRowData);
  }, [selectedRowData]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [tableData, highlightedRow]);

  return (
    <div className="flex flex-col h-screen bg-white">
      <style>
        {`
          .comboborder {
            border: 1px solid #d3d1d1;
          }

          .tfborderblack {
            box-sizing: border-box;
            border: 1px solid rgb(18, 59, 105);
          }
        `}
      </style>

      {customerCode ? (
        <>
          {/* Header */}
          <div className="bg-blue-600 text-white p-1 flex items-center justify-center">
            <h1 className="text-white font-Poppins text-[15px] font-normal leading-[23px] tracking-normal">
              Open Company
            </h1>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-around p-3">
            <button
              className="flex-1 flex items-center justify-center gap-4 mx-2 bg-[#F5F9FE] text-[#0054C3] font-poppins text-base font-medium leading-normal tracking-normal py-4 rounded-lg border-none"
              onClick={handleOpenButtonClick}
            >
              <img src={opnCmp} alt="" className="h-6 w-6" /> Open
            </button>
            <button
              className="flex-1 flex items-center justify-center gap-4 mx-2 bg-[#F5F9FE] text-[#0054C3] font-poppins text-base font-medium leading-normal tracking-normal py-4 rounded-lg border-none"
              onClick={handleExitButtonClick}
            >
              <img src={exit} alt="" className="h-6 w-6" /> Exit
            </button>
          </div>

          {/* Form Section */}
          <div className="p-4 flex flex-col gap-2">
            <label className="text-black font-poppins text-sm font-medium leading-[18px] tracking-[-0.17px]">
              Select Company
            </label>
            <ComboBox
              comboRef={selectcmpref}
              options={companyCode}
              findedValue={
                Array.isArray(cmpData.Cdata) ? cmpData.Cdata[1] : cmpData.Cdata
              }
              className="w-full h-[42px]"
              inputClassName="comboborder rounded-[5px] px-2"
              onInputChange={(e) =>
                setCmpData({
                  ...cmpData,
                  Cdata: e,
                })
              }
              onBlur={() => fetchDatabaseNames()}
              onFocus={() => fetchCmpname()}
            />
          </div>

          {/* Company List */}
          <div className="p-4 space-y-3 overflow-y-auto">
            {tableData.map((rowData, rowIndex) => (
              <div
                key={rowIndex}
                className={`rounded-[8px] h-[64px] p-3 flex ${
                  highlightedRow === rowIndex ? "bg-blue-100" : "bg-[#F5F9FE]"
                }`}
                onClick={() => handleRowClick(rowIndex)}
                onDoubleClick={() => onRowSelect(rowIndex)}
              >
                <div className="flex flex-col w-1/2 h-full">
                  <div
                    className="w-full h-1/2 flex justify-start items-center rounded-[8px] text-black font-Poppins text-sm font-medium leading-[22px] tracking-normal whitespace-nowrap"
                    style={{
                      fontSize:
                        rowData.name?.length > 20 ? "0.75rem" : "0.875rem",
                    }}
                  >
                    {rowData.name}
                  </div>
                  <div className="w-full h-1/2 flex justify-start items-center rounded-[8px] text-black font-poppins text-xs font-medium leading-[22px] tracking-normal">
                    {rowData.Code || "N/A"}
                  </div>
                </div>
                <div className="flex flex-col w-1/2 h-full">
                  <div className="w-full h-1/2 flex justify-end items-center rounded-[8px] text-black font-poppins text-xs font-medium leading-[22px] tracking-normal">
                    {rowData.sdate}
                  </div>
                  <div className="w-full h-1/2 flex justify-end items-center rounded-[8px] text-black font-poppins text-xs font-medium leading-[22px] tracking-normal">
                    {rowData.edate}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          <CustomerCodeVerification
            onClose={() => navigate("/")}
            onVerifyCode={(compData, otp, callback) => {
              setEmailVerificationData(compData);
              setEmailVerificationOtp(otp);
              setEmailVerificationCallback(() => callback);
              setShowEmailVerification(true);
            }}
          />
          {showEmailVerification && (
            <EmailVerification
              onClose={() => setShowEmailVerification(false)}
              data={emailVerificationData}
              generatedOtp={emailVerificationOtp}
              onVerified={(e) => {
                if (emailVerificationCallback) {
                  emailVerificationCallback(e);
                }
              }}
              zIndex={12000}
            />
          )}
        </>
      )}
    </div>
  );
}

export default OpenCompanyMob;
